import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_confirm_copy_step_container';

let ids = {
  BTN_SKIP_COPY: 'BTN_SKIP_COPY',
  BTN_SUBMIT: 'BTN_SUBMIT',
};
ids = addCyPrefixToIDs(cyPrefix, ids);

export const CY_CONFIRM_COPY_STEP_CONTAINER_IDS = ids;
